import { render, staticRenderFns } from "./meeting-overview.vue?vue&type=template&id=2cc80511&scoped=true&"
import script from "./meeting-overview.vue?vue&type=script&lang=ts&"
export * from "./meeting-overview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc80511",
  null
  
)

export default component.exports